import { jsx as _jsx } from "react/jsx-runtime";
import styles from './PointIndication.module.scss';
export const PointIndication = ()=>/*#__PURE__*/ _jsx("div", {
        className: styles.root,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.point
        })
    });
